<button class="back-to-top-btn" (click)="triggerGoTop()">
    <div class="btn-icon">
        <fa-icon [icon]="faChevronUp"></fa-icon>
    </div>
    <div class="btn-text"></div>
</button>